import { Component, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { OAuthAuthService } from '../../data-access/oauth-auth.service';

@Component({
  selector: 'lib-auth-callback',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './auth-callback.component.html',
  styleUrl: './auth-callback.component.scss',
})
export class AuthCallbackComponent implements OnInit {
  private callbackProcessed = false;
  private readonly oauthAuthService = inject(OAuthAuthService);
  private readonly router = inject(Router);

  ngOnInit(): void {
    if (this.callbackProcessed) {
      return;
    }
    this.callbackProcessed = true;

    const urlParams = new URLSearchParams(window.location.search);
    const error = urlParams.get('error');
    const errorDescription = urlParams.get('error_description');

    if (error) {
      sessionStorage.removeItem('auth_redirect_url');

      const errorMessage = errorDescription || error;
      this.router
        .navigate(['/login'], {
          queryParams: {
            authError: error,
            errorMessage: errorMessage,
          },
        })
        .catch(() => {
          window.location.href = '/login?authError=' + encodeURIComponent(error);
        });
      return;
    }

    this.oauthAuthService.handleCallback().subscribe({
      next: (success) => {
        if (!success) {
          sessionStorage.removeItem('auth_redirect_url');
          this.router
            .navigate(['/login'], {
              queryParams: { authError: 'callback_failed' },
            })
            .catch(() => {
              window.location.href = '/login?authError=callback_failed';
            });
        } else {
          setTimeout(() => {
            const redirectUrl = sessionStorage.getItem('auth_redirect_url') || '/dashboard';
            if (window.location.pathname === '/auth/callback') {
              sessionStorage.removeItem('auth_redirect_url');
              this.router.navigateByUrl(redirectUrl).catch(() => {
                window.location.href = redirectUrl;
              });
            }
          }, 500);
        }
      },
      error: () => {
        sessionStorage.removeItem('auth_redirect_url');
        this.router
          .navigate(['/login'], {
            queryParams: { authError: 'callback_error' },
          })
          .catch(() => {
            window.location.href = '/login?authError=callback_error';
          });
      },
    });
  }
}
